'use strict';

angular.module('ntmApp')
  .controller('dailySpeciesChangesController', ['$scope', '$uibModalInstance', '$sce', 'data', 'FlashService', 'Utils', 'GridService',
      function ($scope, $uibModalInstance, $sce, data, FlashService, Utils, GridService) {

        $scope.close = function () {
            $uibModalInstance.close();
        };

        // $scope.dismiss = function () {
        //     $uibModalInstance.close();
        // };

        $scope.updateChangesSetupLevel = function (level) {
            $scope.changesSetupLevel = level;
        };

        $scope.selectSpecies = function (speciesItem) {
          $scope.selectedSpecies = speciesItem;
        };

        $scope.updateSelectedActivityTemplatesList = function () {
          $scope.data.selectedActivityTemplates = getSelectedActivityTemplates();
        }

        $scope.changeDailySpeciesInRoom = function () {

          if (!isValidationPassed()) {
            return;
          }

          var requestData = {
            facilityCode: $scope.data.keyFilters ? $scope.data.keyFilters.FCLTY_CD : null,
            roomNumber: $scope.data.keyFilters ? $scope.data.keyFilters.ROOM_NO : null,
            racksCount: $scope.data.racksCount,
            speciesId: $scope.data.selectedSpecies.speciesCode,
            templateIds: getSelectedActivityTemplates().map(function(activityTemplate) {
              return activityTemplate.templateId;
            })
          }

          var loading = FlashService.Loading();

          GridService.ChangeDailySpeciesInRoom(requestData).then(function (result) {
              
            if (result.success) {
              if ($scope.data.callback) {
                $scope.data.callback();
              }

              loading.dismiss();
              FlashService.Success(result.data.message);
              
              $scope.close();
            }
          });
        };
          
        $scope.$on('modal.closing', function (event, reason) {
            if (reason === 'backdrop click') {
              $scope.close();
            }
        });

        function getSelectedActivityTemplates() {
          return $scope.dataFromServer.activityTemplates.filter(function (activityTemplate) { 
            return activityTemplate.isSelected; 
          });
        }

        function isValidationPassed() {
          var validationErrors = [];

          var selectedTemplates = $scope.dataFromServer.activityTemplates.filter(function (activityTemplate) { 
            return activityTemplate.isSelected; 
          });

          if (!$scope.data.racksCount) {
            validationErrors.push('Racks number is empty.');
          }

          if (!$scope.data.selectedSpecies) {
            validationErrors.push('No species selected.');
          }

          if (!selectedTemplates.length) {
            validationErrors.push('No activity template selected.');
          }

          if (validationErrors.length) {
            var errorsMessageText = getErrorsMessageText(validationErrors);

            FlashService.Error(errorsMessageText);

            return false;
          }

          return true;
        }

        function getErrorsMessageText(validationErrors) {
          
          if (!validationErrors.length) {
            return '';
          }

          var errorsMessageText = 'There are following validation errors: <br><br>';
          
          for (let i = 0; i < validationErrors.length; i++) {
            errorsMessageText += validationErrors[i];

            if (validationErrors.length > 1 && i != validationErrors.length - 1) {
              errorsMessageText += '<br>';
            }
          }

          errorsMessageText += '<br><br>Please fix them before applying Switch Room functionality.';

          errorsMessageText = $sce.trustAsHtml(errorsMessageText);

          return errorsMessageText;
        }

        function getDailySpeciesInRoomDialogInfo() {
          var requestData = {
            facilityCode: $scope.data.keyFilters ? $scope.data.keyFilters.FCLTY_CD : null,
            roomNumber: $scope.data.keyFilters ? $scope.data.keyFilters.ROOM_NO : null
          };

          GridService.GetDailySpeciesInRoomDialogInfo(requestData).then(function (result) {
            
            if (result.success) {
                $scope.dataFromServer = processDataFromServer(result.data);
            }
          });
        }

        function processDataFromServer(dataFromServer) {
          var processedData = {};

          processedData.species = dataFromServer.species;
          processedData.activityTemplates = dataFromServer.templates;

          processedData.activityTemplates.forEach(function (activityTemplate) {
            activityTemplate.isSelected = false;
          });

          return processedData;
        }

        function initData() {
          $scope.data = data;

          $scope.changesSetupLevel = 1;
          $scope.data.racksCount = 1;
          $scope.data.selectedSpecies = null;
          $scope.data.selectedActivityTemplates = [];
          
          getDailySpeciesInRoomDialogInfo();

        }

        initData();

      }]);